import { NgModule, LOCALE_ID } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';

import localeEl from '@angular/common/locales/el';
import { registerLocaleData } from '@angular/common';

import { Platform, PlatformModule } from '@angular/cdk/platform';
import { CustomDateAdapter } from '../globals/classes/CustomDateAdapter';

registerLocaleData(localeEl, 'el');

@NgModule({
	exports: [
		PlatformModule,
		MatNativeDateModule,
		MatDatepickerModule],
	providers: [
		{ provide: LOCALE_ID, useValue: 'el' },
		{ provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE, Platform] },
		{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
	]
})
export class CustomDatePickerModule { }